import React, { useEffect, useState } from 'react'
import { Link, useLoaderData, useNavigate, useRouteLoaderData } from "react-router-dom";
import { useAtomValue } from "jotai";
// import { tokenState } from "./Home";
import NEH from "./NappsEventHandlers";
import { useDeviceWidth } from "./useDeviceWidth";
import { deleteUserTokens } from "./helpers/utils";
import useTokenData from './helpers/tokenData';

/*
class NavBar extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      show_search_modes: false, search_text: 'Nine',
      isLoggedIn: false,
      tokenData: {}
    }
    this.triggerSearchModes = this.triggerSearchModes.bind(this)
    // let loginToken;
    this.loginToken = localStorage.getItem("nine_login")
  }

  componentDidMount () {
    this.search_transition_id = setInterval(() => this.changeSearchText(), 10000)

    // fetch(`http://127.0.0.0:5000/apps/${}`).then()

    console.log(this.loginToken)
    this.loginToken === null ? this.setState({isLoggedIn: false}) : this.setState({isLoggedIn: true});
    console.log(this.state.isLoggedIn)
    this.state.isLoggedIn
        ? this.setState({tokenData: JSON.parse(decodeToken(this.loginToken))})
        : this.setState({tokenData: {}});
    console.log(this.state.isLoggedIn)
    console.log(this.state.tokenData)
  }

  componentWillUnmount () {
    clearInterval(this.search_transition_id)
    // this.search_transition_id = setInterval(function() {
    // 	document.querySelector("#id-napps-navbar-search").innerHTML = "Nine";
    // }, 1000);
  }

  changeSearchText () {
    this.setState({
      search_text: this.state.search_text === 'Nine' ? 'Search Apps...' : 'Nine',
    })
  }

  triggerSearchModes () {
    // this.setState({
    // 	show_search_modes: true,
    // });
    // document.getElementById("id-napps-search").classList.add("modes-show");
    new NEH().drawSearchTemplate()
  }

  render () {
    return (
      <section
        className="sticky top-0 flex-noshrink flex flex-column justify-center align-item-center bg-white-solid h-10 z-index-100">
        <header className={"font-16 font-bold pad-x2"}>Nine</header>
        <div className={"abs flex justify-end align-items-center flex-basis flex-grow right-4"}>
          <div className={"navbar-search fa fa-search square-4 lh-4 text-center mg-x2 mg-t-4 radius-circle font-12 font-semibold sm:font-semibold"}></div>
          <img alt={this.state.isLoggedIn ? this.state.tokenData.email : ""}
               className="relative square-5 lh-5 radius-circle bg-lighter border-0 border-DDD border-solid bg-green-inverse cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease"

          />
        </div>
        {/!*<section className="navbar align-self-center pct:w-100 w-safe-12 h-8 line-height-8 radius-sm text-center bg-white">*!/}
        {/!*  /!* <div className="navbar-options grid-x1 flex-y justify-center align-center">*!/}
        {/!*				<div className="square-5 radius bg-lighter"></div>*!/}
        {/!*			</div> *!/!*!/}
        {/!*  <div id="id-napps-navbar-search"*!/}
        {/!*       className="navbar-search text-center font-17 font-semibold sm:font-semibold bg-lighter pct:w-64 sm:pct:w-100 mg-auto sm:bg-unset radius"*!/}
        {/!*       onClick={this.triggerSearchModes}>*!/}
        {/!*    {this.state.search_text}*!/}
        {/!*  </div>*!/}
        {/!*  <span className="fa fa-bars abs top-0 left-0 square-10 lh-10 radius-sm font-16 color-397D54"></span>*!/}
        {/!*  <div className="abs flex justify-center align-items-center top-0 right-0 square-10 lh-10 radius-sm">*!/}
        {/!*    <img alt=""*!/}
        {/!*         className="relative square-5 lh-5 radius-circle bg-lighter border-0 border-DDD border-solid bg-green-inverse cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease"/>*!/}
        {/!*  </div>*!/}
        {/!*  /!* <div className="navbar-user grid-x1 h-safe-12 flex-y justify-center align-center text-center">*!/}
        {/!*				<div className="navbar-user-dp bg-light radius-circle square-5"></div>*!/}
        {/!*			</div> *!/!*!/}
        {/!*</section>*!/}
      </section>
    )
  }
}
*/


const NavBar = ({ header, showAddAppButton = false, showSearch, showProfile, hideVerifiedButton, children }) => {
    const { me } = useRouteLoaderData("root");
    const { rawToken, isLoggedIn, tokenData } = useTokenData();
    // const { rawToken, isLoggedIn, tokenData } = useAtomValue(tokenState);
    // const {rawToken, isLoggedIn, tokenData} = useRecoilValue(tokenState);
    const accessToken = window.localStorage.getItem('nine_login');

    const navigate = useNavigate();
    const width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
    const { windowWidth, screenWidth, deviceWidthEnum } = useDeviceWidth();

    const logout = () => {
        // localStorage.removeItem("nine_login");
        // localStorage.removeItem("nine_refresh");
        deleteUserTokens()
        // setIsLoggedIn(false);
        // Refresh the page to delete stale states and data
        navigate(0);
    }

    return (
        <section
            className="sticky top-0 flex-noshrink flex flex-column justify-center align-item-center pct:w-100 h-10 bg-white-solid z-100 dark:bg-111314">
            <Link to={"/"} className={"flex flex-row align-items-center pct:h-100 font-16 font-bold pad-x3 decoration-none color-initial dark:color-whitesmoke"}>{header || "Nine"}</Link>
            <div className={"abs flex justify-end align-items-center flex-basis flex-grow right-4 lg:right-1"}>
                {
                    showSearch !== false && <Link to={"/search"}
                        className={"navbar-search relative fa fa-search square-4 lh-4 text-center mg-x2 mg-t-4 radius-circle border-0 bg-transparent font-14 font-semibold sm:font-semibold decoration-none color-initial hover:bg-lighter lg:square-8|lh-8 dark:color-lighter dark:hover:bg-222425BB"}></Link>
                }
                {
                    showProfile !== false && <div className={"relative parent-user z-100"}>
                        {
                            isLoggedIn
                                ? (
                                    me?.data?.dp
                                        ? <img alt=""
                                            width={"40"}
                                            height={"40"}
                                            className="sibling-user relative square-5 lh-5 radius-circle bg-lighter border-0 border-DDD border-solid bg-green-inverse cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease"
                                            src={me?.data?.dp}
                                        />
                                        : <div
                                            className={"sibling-user relative square-5 lh-5 radius-circle bg-lighter border-0 border-DDD border-solid bg-green-inverse text-center font-11 font-bold cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease lg:font-12 dark:color-darkgray dark:hover:shadow:inset-0px-0px-8px-0px-222324"}>
                                            {
                                                me?.data?.firstname
                                                    ? me?.data?.firstname?.split('')[0].toUpperCase() + me?.data?.lastname?.split('')[0].toUpperCase()
                                                    : tokenData?.firstname?.split('')[0].toUpperCase() + tokenData?.lastname?.split('')[0].toUpperCase()
                                            }
                                        </div>
                                )
                                : <div
                                    className={"sibling-user relative square-5 lh-5 radius-circle bg-lighter border-0 border-DDD border-solid bg-green-inverse text-center font-bold cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease dark:hover:shadow:inset-0px-0px-8px-0px-222324"}>
                                </div>
                        }
                        {/*<Modes modes_id="id-app-details-modes" modes_class="modes modes-white modes-fullscreen" show_modes={true}>akhdkagsehabhu</Modes>*/}
                        <ul id="id-user-dropdown"
                            className="nav-dropdown invisible d-block abs z-1100 pad-1 top-100 right-0 mg-t1 bg-white bg-mica radius shadow hover:child-user:visible|mg-t-4 all:d-block|pct:w-100|text-left|decoration-none|color-initial transition:margin_200ms_ease|visibility_100ms_ease|top_200ms_ease_200ms every:d-block|list-type-none|pad-x3|pad-y2|w-200 hover:every:bg-green-inverse|radius-inherit every:transition:background_200ms_ease dark:bg-00030488|shadow-unset dark:all:color-whitesmoke">
                            {
                                isLoggedIn
                                    ? (
                                        <>
                                            <Link to={"/profile"} className={""}>Profile</Link>
                                            <Link to={"/"} onClick={logout}>Logout</Link>
                                        </>
                                    )
                                    : (
                                        <>
                                            <Link to={"/signup"} className={"font-bold"}>Signup</Link>
                                            <Link to={"/login"} className={""}>Login</Link>
                                        </>
                                    )
                            }
                            <Link to={"/privacy"}
                                className={"border:0px_solid_EEEE em:border-t-0.04 dark:border-t-0"}>Privacy</Link>
                            <Link to={"/terms"}>Terms of Service</Link>
                            <Link to={"/about"}>About Nine</Link>
                            {/* <button type={"button"} className={"border-0 radius mg-y2 bg-green color-white cursor-pointer"} onClick={InstallPWAButton}>
                                Install Nine
                            </button> */}
                        </ul>
                    </div>
                }
                {/*{
                    isLoggedIn && tokenData?.is_verified === undefined && !tokenData?.is_verified
                        ? <Link
                            to={"/verify-user"}
                            className={"h-5 lh-5 mg-l2 pad-x2 bg-yellow color-black text-center radius decoration-none"}
                        >
                            Verify account
                        </Link>
                        : null
                }*/}
                {
                    showAddAppButton && (
                        windowWidth >= deviceWidthEnum.laptop
                            ? <div className={"d-block h-7 lh-7 mg-l4 pad-l4 border:0px_solid_DDD border-l-1 dark:border:0px_solid_333536 dark:border-l-1"}>
                                {/*<span className={"border:0px_solid_lightgray border-l-1"}></span>*/}
                                <Link to={accessToken ? "/new" : "/login"}
                                    className="d-block z-100 h-7 line-height-7 pad-x4 radius2 bg-green-solid nine-blue-bg color-white cursor-pointer font-semibold decoration-none">
                                    Add your App
                                </Link>
                            </div>
                            : <Link to={accessToken ? "/new" : "/login"}
                                className="fixed right-8 top-initial bottom-4 z-100 h-8 line-height-8 radius2 bg-green-solid nine-blue-bg color-white pad-x4 cursor-pointer font-semibold shadow:0px-0px-16px-4px-73C088 decoration-none dark:shadow-unset">
                                Add your App
                            </Link>
                    )
                }
            </div>
        </section>
    )
}

export default NavBar